var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallLogoPurple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1533 0H1.84926C0.828632 0 0 0.828632 0 1.84926V38.1507C0 39.1739 0.828632 40 1.84926 40H38.1533C39.1739 40 40 39.1739 40 38.1507V1.84926C40 0.828632 39.1739 0 38.1533 0ZM27.5015 30.7352L21.0935 13.7482C20.9116 13.2808 20.5453 13.0442 20.0518 13.0442C19.5558 13.0442 19.192 13.2804 18.9815 13.7482L12.3141 30.7352H8.24926L15.6493 11.9768C16.0387 10.9874 16.6131 10.2834 17.3141 9.86779C18.0438 9.44968 18.9558 9.26779 20.0779 9.26779C21.1975 9.26779 22.1091 9.44968 22.8131 9.86779C23.5427 10.2834 24.0884 10.9874 24.4547 11.9768L31.5924 30.7352H27.5015Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallLogoPurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smallLogoPurple.ea3b2dd9f724c1843cc966bbbd04d17a.svg";